import styled from 'styled-components';

import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';

import { breakPoints } from '~/src/constants/breakpoints';

export const Wrapper = styled.div`
    display: flex;
    width: auto;
    flex-wrap: nowrap;
    justify-content: space-around;
`;

export const GridContainerTabs = styled(GridContainer)`
    flex-direction: column;
    margin-top: 41px;
    padding-bottom: 10px;
    overflow: scroll;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;

    &::-webkit-scrollbar { 
        width: 0;
    }

    @media (max-width: 1279px) {
        width: 1424px;
    }
    
    @media (max-width: ${breakPoints.mobile}) {
         margin-top: 10px;
         margin-bottom: 0;
    }
`;

